// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import Icon from '../../_common/form/Icon';

const riseUp = keyframes`
    from{
        transform: translateY(101%)
    }
    to {
        transform: translateY(0%)
    }
`;

const Wrapper = styled.div`
    display: flex;
    position: absolute;
    bottom: ${({ height }) => height}px;
    right: ${({ show }) => show ? '10%' : '-10%'};
    transition: all 0.2s ease-out;

    height: 5%;
    z-index: 98;
    animation: ${riseUp};
    animation-duration: 0.5s;
    animation-fill-mode: forwards;
`

const RelativeWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

const HistoryButton = styled.div`
    position: absolute;
    top: 0;
    background-color: ${({ theme }) => theme.mobile.white};
    color: ${({ theme }) => theme.gray};

    user-select: none;

    height: 100%;
    width: 10vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 1rem;
    box-shadow: -2px -2px 5px 0px ${({ theme }) => theme.mobile.shadow};
`

const History = ({ ...props }) => {
    const history = useNavigate()
    let height = document.getElementById('NavigationBar');
    if (!height) return null;
    height = height.getClientRects()
    const handleGoBack = () => {

        const content = document.querySelector('#content_wrapper');
        content.style.overflow = 'hidden';
        history(-1);
        setTimeout(() => {
            content.style.overflow = 'overlay';
        }, 50)
        
    }
    return (
        <Wrapper height={height[0].height} show={window.location.pathname !== '/'}>
            <RelativeWrapper>
                <HistoryButton onClick={() => handleGoBack()} >
                    <Icon icon='circleChevronLeft' />
                </HistoryButton>
            </RelativeWrapper>
        </Wrapper>
    );
}

export default History;